import { markReloadingAfterPreloadError } from './preloadReloadState';

const LAST_RELOAD_KEY = 'vite:preloadError:lastReload';

// After a reload we give the fresh assets this long to load. If another preload
// error fires within the window, the chunk is genuinely missing (not just stale
// from a deploy), so we stop reloading and let the error surface instead of looping.
const RELOAD_DEBOUNCE_MS = 10_000;

/**
 * Recover from stale lazy-loaded chunks after a deploy.
 *
 * Vite splits dynamic `import()`s into content-hashed chunks. When a new version
 * is deployed, the old chunk files are removed from the server. A browser tab that
 * was opened before the deploy still references the old hashes, so the first
 * `import()` of a not-yet-loaded chunk 404s and Vite emits `vite:preloadError`.
 * We reload once to pull the current build, guarded so a chunk that is missing for
 * any other reason can't trigger a reload loop.
 */
export function registerVitePreloadErrorHandler(): void {
  window.addEventListener('vite:preloadError', (event) => {
    const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);

    if (Date.now() - lastReload < RELOAD_DEBOUNCE_MS) {
      return;
    }

    event.preventDefault();
    markReloadingAfterPreloadError();
    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    window.location.reload();
  });
}
